module.exports = __webpack_public_path__ + "media/newstyle/images/privacidade2-5861e5faf2ff2dd19535f3a6eac90d31.png";